import { KeyOfType } from 'types';

export const routes = {
    landingPage: '/',
    signIn: '/sign-in',
    callback: '/callback',
    notFound: '/not-found',
    joinEvent: '/join',
    content: '/content',
    workshops: '/workshops',
    embeddedWorkshops: '/v2/workshops',
    lobby: '/lobby',
    events: '/event',
};

export type RouteParamKeys = KeyOfType<typeof routeParams>;
export type RouteParams = { [key in RouteParamKeys]?: string };

export const routePaths = {
    latest: '$LATEST',
    builds: 'builds',
    dashboard: 'dashboard',
    accountLogin: 'account-login',
    login: 'login',
};

export const routeParams = {
    contentId: 'contentId',
    buildNumber: 'buildNumber',
    contentBuildId: 'contentBuildId',
    quickLinkId: 'quickLinkId',
};
